export default __webpack_public_path__ + "static/media/preloader.9e9cce4f.gif";